export const ShowStickyCTAButton = {
  mounted() {
    this.maybeShowStickyButton();
  },
  updated() {
    this.maybeShowStickyButton();
  },
  maybeShowStickyButton() {
    const stickyButtonContainer = this.el;
    const staticCTAButton = document.querySelector('[data-behavior=addToCart]');

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver(
      (elements) => {
        elements.map(function (element) {
          if (window.experimentation.showStickyATBCalled) {
            // Toggle button visibility
            stickyButtonContainer.classList.toggle('translate-y-20', element.isIntersecting);

            // If now visible, send experimentation event
            if (!stickyButtonContainer.classList.contains('translate-y-20')) {
              // Only send event first time button is shown
              if (!window.experimentation.stickyATBEventSent) {
                window.dispatchEvent(new CustomEvent('experimentation.stickyATBShown'));
                window.experimentation.stickyATBEventSent = true;
              }
            }
          }
        });
      },
      { threshold: 1.0, rootMargin: '-7px 0px 1024px 0px' }
    );

    this.observer.observe(staticCTAButton);
  }
};
